<template>
  <div class="referral-tab container h-100">
    <div class="row h-100 text-center d-flex flex-column flex-lg-row">
      <div class="col-lg-6 pt-lg-5">
        <p class="small text-primary mb-lg-5">
          {{ $t("home.profile_referral_description") }}
        </p>
        <div class="w-100 mb-lg-5">
          <b-button
            v-if="user.referralCount < user.referralLimit"
            @click="
              openSharePopup();
              btnSfx();
            "
            variant="primary"
            class="shareBtn mb-3"
            size="lg"
          >
            {{ $t("home.profile_referral_share_btn") }}
            <progress-bar
              type="circle"
              ref="circle"
              :options="progressOptions"
              class="timer animate__animated animate__zoomIn animate__faster"
            ></progress-bar>
          </b-button>
          <h4 v-else class="withCircle">
            {{ $t("home.profile_referral_share_info") }}
            <progress-bar
              type="circle"
              ref="circle"
              :options="progressOptions"
              class="timer animate__animated animate__zoomIn animate__faster"
            ></progress-bar>
          </h4>
        </div>

        <div class="row total-box mb-4">
          <div class="col-4 pr-0"><img src="/images/cup-tokens.png" /></div>
          <div class="col-8">
            <div class="text-orange mt-3">
              {{ $t("home.profile_referral_profit_title") }}
            </div>
            <h1 class="mb-1">
              <b>{{ total.abbr(true) }}</b>
            </h1>
            <div class="text-orange">
              {{ $t("home.profile_referral_profit_currency") }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 flex-fill pt-lg-3 pb-lg-3">
        <b-tabs
          v-model="currentTab"
          content-class="referralList h-100 relative"
          fill
          @activate-tab="tabSet"
        >
          <b-tab :title="$t('home.profile_referral_tab_week')">
            <span
              v-if="weekList.length == 0"
              class="text-primary m-auto"
              v-html="$t('home.profile_referral_tab_no_data')"
            ></span>
            <ul v-else>
              <li v-for="(w, index) in weekList" :key="index">
                <img
                  :src="
                    w.user.avatarUrl != undefined
                      ? w.user.avatarUrl
                      : '/images/male-default.png'
                  "
                />
                <h5 class="mb-0">{{ w.user.username }}</h5>
                <span
                  ><img src="/images/token.png" />
                  <b>{{ Math.floor(w.profit).abbr(true) }}</b></span
                >
                <div class="ml-2 mr-2">
                  <div class="text-primary">
                    <small>{{
                      $t("home.profile_referral_list_fill_title")
                    }}</small>
                  </div>
                  <div class="d-flex">
                    <div class="fill">
                      <span
                        :style="
                          'width:' +
                          (w.profit - Math.floor(w.profit)) * 100 +
                          '%;'
                        "
                      ></span>
                    </div>
                    <span class="percent"
                      >{{
                        parseInt((w.profit - Math.floor(w.profit)) * 100)
                      }}%</span
                    >
                  </div>
                </div>
              </li>
            </ul>
          </b-tab>
          <b-tab :title="$t('home.profile_referral_tab_all_time')">
            <span
              v-if="allList.length == 0"
              class="text-primary m-auto"
              v-html="
                $t(
                  user.referralCount > 0
                    ? 'home.profile_referral_tab_no_data2'
                    : 'home.profile_referral_tab_no_data'
                )
              "
            ></span>
            <ul v-else>
              <li v-for="(w, index) in allList" :key="index">
                <img
                  :src="
                    w.user.avatarUrl != undefined
                      ? w.user.avatarUrl
                      : '/images/male-default.png'
                  "
                />
                <h5 class="mb-0">{{ w.user.username }}</h5>
                <span
                  ><img src="/images/token.png" />
                  <b>{{ Math.floor(w.profit).abbr(true) }}</b></span
                >
                <div class="ml-2 mr-2">
                  <div class="text-primary">
                    <small>{{
                      $t("home.profile_referral_list_fill_title")
                    }}</small>
                  </div>
                  <div class="d-flex">
                    <div class="fill">
                      <span
                        :style="
                          'width:' +
                          (w.profit - Math.floor(w.profit)) * 100 +
                          '%;'
                        "
                      ></span>
                    </div>
                    <span class="percent"
                      >{{
                        parseInt((w.profit - Math.floor(w.profit)) * 100)
                      }}%</span
                    >
                  </div>
                </div>
              </li>
            </ul>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <share-popup ref="sharePopup"></share-popup>
  </div>
</template>
<script>
import Vue from "vue";
import SharePopup from "../components/SharePopup.vue";

import api from "../api";

const HomeReferralTab = Vue.component("home-referral-tab", {
  components: {
    SharePopup,
  },

  props: {
    tab: Number,
  },

  data() {
    return {
      total: 0,
      weekList: [],
      allList: [],
      period: "P7D",
      page: 1,
      allLoaded: false,
      lock: false,
      currentTab: 0,
      progressOptions: {
        color: "#ffc600",
        trailColor: "#abccee",
        strokeWidth: 10,
        trailWidth: 10,
        from: { color: "#ffc600" },
        to: { color: "#ffc600" },
        step: function (state, circle, attachment) {
          circle.path.setAttribute("stroke", state.color);
        },
      },
    };
  },
  methods: {
    btnSfx() {
      this.$store.dispatch("sound/sfx", "Button");
    },

    openSharePopup() {
      this.$refs.sharePopup.show();
    },

    tabSet(tab, silent) {
      if (silent !== true) this.btnSfx();
      const $this = this;
      this.allLoaded = false;
      this.lock = false;
      this.period = tab == 0 ? "P7D" : undefined;

      api
        .referralProfit(this.period)
        .then((response) => {
          $this.total = response.data;
        })
        .catch((error) => {
          api.baseErrorHendler(error);
        });

      this.getList(1);
    },

    getList(page) {
      const $this = this;
      if (this.allLoaded || this.lock) return;
      this.lock = true;

      if (page == undefined) {
        page = this.page + 1;
      }

      api
        .referralMy(this.period, page)
        .then((response) => {
          $this.page = page;

          if (page == 1) {
            if ($this.period == undefined) $this.allList = [];
            else $this.weekList = [];

            const listElm = document.querySelector(".referralList .tab-pane");
            listElm.addEventListener("scroll", (e) => {
              let bottom =
                Math.abs(
                  listElm.scrollHeight -
                    (listElm.scrollTop + listElm.clientHeight)
                ) < 1;
              if (bottom) {
                $this.getList();
              }
            });
          }

          if ($this.period == undefined)
            $this.allList = $this.allList.concat(response.data);
          else $this.weekList = $this.weekList.concat(response.data);

          if (response.data.length == 0) $this.allLoaded = true;
        })
        .catch((error) => {
          api.baseErrorHendler(error);
        })
        .then(() => {
          $this.lock = false;
        });
    },
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },

  created() {
    this.currentTab = this.tab;
    this.tabSet(this.currentTab, true);
  },

  mounted() {
    this.$refs.circle.animate(
      this.user.referralCount / this.user.referralLimit
    );
    this.$refs.circle.setText(
      this.user.referralCount + "/" + this.user.referralLimit
    );
  },

  beforeDestroy() {
    document.getElementById("loader").classList.remove("show");
  },

  watch: {
    tab() {
      this.currentTab = this.tab;
      this.tabSet(this.currentTab, true);
    },
  },
});

export default HomeReferralTab;
</script>
